// 存放公共常量
const COMMON_CONSTANTS = {
	CAR_TYPE: {
		1: {
			value: 10,
			desc: '惠享'
		},
		2: {
			value: 1,
			desc: '经济'
		},
		3: {
			value: 9,
			desc: '优选'
		},
		4: {
			value: 2,
			desc: '舒适'
		},
		5: {
			value: 3,
			desc: '商务'
		},
		6: {
			value: 4,
			desc: '豪华'
		}
	},
	// 预约车型
	BOOKING_CAR_TYPE: {
		1: {
			value: 1,
			desc: '经济'
		},
		9: {
			value: 9,
			desc: '优选'
		},
		10: {
			value: 10,
			desc: '惠享'
		},
		2: {
			value: 2,
			desc: '舒适'
		},
		3: {
			value: 3,
			desc: '商务'
		},
		4: {
			value: 4,
			desc: '豪华'
		}
	},
	// 订单类型
	ORDER_TYPE: {
		// 1: {
		//   value: 1,
		//   desc: '预留类型'
		// },
		2: {
			value: 2,
			desc: '导游用车'
		},
		3: {
			value: 3,
			desc: '半日租'
		},
		4: {
			value: 4,
			desc: '日租'
		},
		5: {
			value: 5,
			desc: '即时用车'
		},
		11: {
			value: 11,
			desc: '接机'
		},
		12: {
			value: 12,
			desc: '送机'
		},
		15: {
			value: 15,
			desc: '预约一口价'
		},
		16: {
			value: 16,
			desc: '预约实时计价'
		},
		21: {
			value: 21,
			desc: '接站'
		},
		22: {
			value: 22,
			desc: '送站'
		}
	},
	// 预约订单类型
	ORDER_BOOKING_TYPE: {
		11: {
			value: 11,
			desc: '接机'
		},
		12: {
			value: 12,
			desc: '送机'
		},
		15: {
			value: 15,
			desc: '预约一口价'
		},
		21: {
			value: 21,
			desc: '接站'
		},
		22: {
			value: 22,
			desc: '送站'
		}
	},
	// 预约实时计价
	ORDER_BOOKING_REAL_TIME_TYPE: {
		16: {
			value: 16,
			desc: '预约实时计价'
		}
	},
	// 即时
	ORDER_IMMEDIATELY_TYPE: {
		5: {
			value: 5,
			desc: '即时'
		}
	},
	// 星期
	WEEK_LIST: {
		1: {
			value: 1,
			desc: '周一'
		},
		2: {
			value: 2,
			desc: '周二'
		},
		3: {
			value: 3,
			desc: '周三'
		},
		4: {
			value: 4,
			desc: '周四'
		},
		5: {
			value: 5,
			desc: '周五'
		},
		6: {
			value: 6,
			desc: '周六'
		},
		7: {
			value: 7,
			desc: '周日'
		}
	},
	// 订单状态
	ORDER_STATUS: {
		1: { value: 1, desc: '待接单' },
		2: { value: 2, desc: '司机预接单' },
		3: { value: 3, desc: '司机已接单' },
		5: { value: 5, desc: '已出发接乘客/接驾中' },
		7: { value: 7, desc: ' 已到达出发地' },
		9: { value: 9, desc: '已上车' },
		11: { value: 11, desc: '已到达目的地' },
		13: { value: 13, desc: '已完单' },
		15: { value: 15, desc: '已取消' },
		17: { value: 17, desc: '车队已接单' }
	}
}
export default COMMON_CONSTANTS
